import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import ReceitaForm from "@/components/ReceitaForm";
import axios from "axios";
import { toast } from "sonner";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const NovaReceita = () => {
  const navigate = useNavigate();
  const location = useLocation();
  
  // Verifica se está duplicando uma receita existente
  const duplicarDe = location.state?.duplicarDe;
  
  // Prepara dados iniciais para duplicação (copia cliente e receita, limpa valores/pagamento)
  const dadosIniciais = duplicarDe ? {
    // Dados do cliente (copiados)
    nome_cliente: duplicarDe.nome_cliente,
    cpf_cliente: duplicarDe.cpf_cliente,
    telefone_cliente: duplicarDe.telefone_cliente,
    // Dados da receita/grau (copiados)
    od_esf: duplicarDe.od_esf,
    od_cil: duplicarDe.od_cil,
    od_eixo: duplicarDe.od_eixo,
    od_adicao: duplicarDe.od_adicao,
    oe_esf: duplicarDe.oe_esf,
    oe_cil: duplicarDe.oe_cil,
    oe_eixo: duplicarDe.oe_eixo,
    oe_adicao: duplicarDe.oe_adicao,
    dnp_od: duplicarDe.dnp_od,
    dnp_oe: duplicarDe.dnp_oe,
    altura_od: duplicarDe.altura_od,
    altura_oe: duplicarDe.altura_oe,
    // Data da receita (copiada)
    data_receita: duplicarDe.data_receita,
    // Loja (copiada)
    nome_loja: duplicarDe.nome_loja,
    // Campos que precisam ser preenchidos novamente
    os: "", // Nova OS
    tipo_produto: "", // Novo tipo de produto
    referencia: "", // Nova referência
    nome_laboratorio: "",
    tipo_lente: "",
    valor_lente: null,
    valor_total: null,
    forma_pagamento: null,
    formas_pagamento: [{ forma: "", valor: "", parcelas: null }],
    observacoes: "",
    fotos: [],
  } : null;

  const handleSubmit = async (data, pendingFiles = []) => {
    try {
      const res = await axios.post(`${API}/receitas`, data);
      const receitaId = res.data.id;

      if (pendingFiles.length > 0) {
        for (const file of pendingFiles) {
          const formData = new FormData();
          formData.append("file", file);
          try {
            await axios.post(`${API}/receitas/${receitaId}/fotos`, formData);
          } catch {
            toast.error(`Erro ao enviar foto: ${file.name}`);
          }
        }
        toast.success(`Receita criada com ${pendingFiles.length} foto(s)!`);
      } else {
        toast.success("Receita criada com sucesso!");
      }
      navigate("/receitas");
    } catch {
      toast.error("Erro ao criar receita");
    }
  };

  return (
    <div data-testid="nova-receita-container">
      <Card className="bg-white border border-slate-200 shadow-sm">
        <CardHeader className="bg-slate-50 border-b border-slate-200">
          <CardTitle className="text-2xl font-semibold text-slate-900">
            {duplicarDe ? "Duplicar OS" : "Nova Receita"}
          </CardTitle>
          <p className="text-sm text-slate-500 mt-2">
            {duplicarDe 
              ? `Duplicando OS do cliente ${duplicarDe.nome_cliente || ""}. Dados do cliente e receita foram copiados. Preencha os dados do novo produto.`
              : "Preencha os campos desejados. Nenhum campo e obrigatorio."
            }
          </p>
          {duplicarDe && (
            <div className="mt-3 p-3 bg-blue-50 border border-blue-200 rounded-lg">
              <p className="text-sm text-blue-700 font-medium">
                Dados copiados: Cliente, CPF, Telefone, Grau (OD/OE), DNP, Altura, Loja
              </p>
              <p className="text-xs text-blue-600 mt-1">
                Preencha: OS, Tipo de Produto, Laboratorio, Lente, Valor e Pagamento
              </p>
            </div>
          )}
        </CardHeader>
        <CardContent className="pt-6">
          <ReceitaForm 
            initialData={dadosIniciais}
            onSubmit={handleSubmit} 
            onCancel={() => navigate("/receitas")} 
          />
        </CardContent>
      </Card>
    </div>
  );
};

export default NovaReceita;
